"use strict";
// @ts-ignore
try {
    self['workbox:window:6.5.4'] && _();
}
catch (e) { }
